import styled from 'styled-components';
import SidebarComponent from '@/components/Sidebar';

export const PageGrid = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    justify-content: space-between;
    gap: 24px;
    flex-direction: row;
  }
`;

export const Content = styled.div`
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: calc(100% - 300px);
  }
`;

export const Sidebar = styled(SidebarComponent)`
  top: 67px;
`;
